import React, { useContext, useEffect, useRef, useState } from "react";
import { Accordion, Group, Radio } from "@mantine/core";
import { BsBoxSeam } from "react-icons/bs";
import autoAnimate from "@formkit/auto-animate";
import Responsible from "../../Components/Responsible";
import { AppContext, SET_DELIVERY_METHOD } from "../../context";
import { useMediaQuery } from "@mantine/hooks";
import { FaRegUser } from "react-icons/fa";
import {
  getMethodById,
  GIFTCERTIFICATE,
} from "../../Components/Payments/constants";
import { commitPurchase } from "../../Components/Common/util";
import { useDispatch } from "react-redux";
import Asterisk from "./Icons/Asterisk";
import { getInitial } from "../../Components/Responsible/util";

const ChooseDelivery = ({
  sale,
  classes,
  language,
  deliveryMethods,
  handleSelect,
  fee,
  authenticated,
  hasFee,
  newId,
  responsible,
  selected,
  setSelected,
  ticketOwners,
  selectedDeliveryMethod,
  providesResponsible,
  config,
  setIsOnePageCheckoutActive,
  culture,
  currency,
  whoami,
  validateForm,
}) => {
  const [value, setValue] = useState(null);
  const [accordionValue, setAccordionValue] = useState([
    "delivery",
    "customer",
  ]);
  const [name, setName] = useState(null);
  const isMobile = useMediaQuery("(max-width: 950px)");
  const parent = useRef(null);
  const informationParent = useRef(null);
  const context = useContext(AppContext);
  const ctxDispatch = context.dispatch;
  const rdxDispatch = useDispatch();
  const { hasOptedIn } = context;
  const { paymentMethodId } = context.state;
  const deliveryMethod = sale?.deliveryMethod;

  const delivery = (val) => {
    const filter = deliveryMethods.filter((el) => el.id === val)?.[0]?.name;
    setValue(val);
    setName(filter);
    ctxDispatch({ type: SET_DELIVERY_METHOD, payload: filter });
    handleSelect(val);
  };

  useEffect(() => {
    if (value) {
      setAccordionValue(["customer", "delivery"]);
    }
  }, [value]);

  useEffect(() => {
    parent.current && autoAnimate(parent.current);
    informationParent.current && autoAnimate(informationParent.current);
  }, [parent, informationParent]);

  useEffect(() => {
    const filterMethods = deliveryMethods.filter(
      (el) => el.id === sale.deliveryMethod
    );
    if (filterMethods.length > 0) {
      setValue(filterMethods?.[0]?.id);
      setName(filterMethods?.[0]?.name);
    }
  }, [sale]);

  useEffect(() => {
    validateForm();
  }, [deliveryMethod]);

  useEffect(() => {
    if (deliveryMethods && deliveryMethods.length === 1) {
      delivery(deliveryMethods[0].id);
    }
  }, [deliveryMethods]);

  const identifier = context.state.identifier;

  const isDeliveryOpen = accordionValue?.includes("delivery");

  const values = getInitial(
    newId,
    selected,
    ticketOwners,
    whoami,
    sale?.responsible
  );

  const commitGiftCertificate = {
    paymentMethodId,
    identifier,
    culture,
    currency,
    responsible: responsible ? responsible : values,
    optIn: hasOptedIn,
  };

  const submitNoToggleTerms = () => {
    const selectedMethod = getMethodById(paymentMethodId);
    commitPurchase(
      config.apiUri,
      sale.id,
      selectedMethod.supportsOnePage,
      setIsOnePageCheckoutActive,
      rdxDispatch,
      commitGiftCertificate
    );
  };

  const hideDeliveryMethodChooser =
    config?.hideDeliveryMethodChooser && deliveryMethods.length === 1;

  const hideAccordion =
    !providesResponsible &&
    (deliveryMethods.length === 0 || hideDeliveryMethodChooser);

  return (
    <div ref={informationParent}>
      {!hideAccordion && (
        <div className={classes.step}>
          <Accordion
            className={classes.accordion}
            classNames={{
              chevron: classes.accordionChevron,
              icon: classes.accordionIcon,
              control: classes.accordionControl,
            }}
            variant="contained"
            value={accordionValue}
            onChange={setAccordionValue}
            defaultValue={["customer"]}
            multiple
          >
            {!hideDeliveryMethodChooser &&
              deliveryMethods &&
              deliveryMethods.length > 0 && (
                <Accordion.Item value="delivery">
                  <Accordion.Control icon={<BsBoxSeam aria-hidden="true" />}>
                    <div ref={parent}>
                      <h2 className={classes.accordionTitle}>
                        {language.Delivery}
                      </h2>
                      {name && !isDeliveryOpen && (
                        <span className={classes.accordionSubTitle}>
                          {language.DeliveryMethodNames[name] || name}
                        </span>
                      )}
                    </div>
                  </Accordion.Control>
                  <Accordion.Panel>
                    <Radio.Group
                      value={value}
                      onChange={delivery}
                      name="delivery"
                      label={language.Step_Delivery_Sub_Helper}
                      withAsterisk
                      required={true}
                      aria-disabled={deliveryMethods.length === 1}
                    >
                      <Group
                        pt="10px"
                        gap={"20px"}
                        style={{
                          flexDirection: isMobile ? "column" : "row",
                          alignItems: isMobile ? "flex-start" : "center",
                        }}
                      >
                        {deliveryMethods &&
                          deliveryMethods.map((method) => {
                            return (
                              <Radio
                                key={method.id}
                                value={method.id}
                                disabled={deliveryMethods.length === 1}
                                label={`${
                                  method.id === "Mail"
                                    ? language.DeliveryMethodNames[
                                        method.name
                                      ] +
                                      " - " +
                                      fee
                                    : language.DeliveryMethodNames[
                                        method.name
                                      ] || method.name
                                }`}
                              />
                            );
                          })}
                      </Group>
                    </Radio.Group>
                  </Accordion.Panel>
                </Accordion.Item>
              )}
            {providesResponsible && (
              <Accordion.Item value="customer">
                <Accordion.Control icon={<FaRegUser aria-hidden="true" />}>
                  <div>
                    <h2 className={classes.accordionTitle}>
                      {language.Step_Responsible_Head}
                      <Asterisk strokeWidth={4} padding={"12px"} />
                    </h2>
                  </div>
                </Accordion.Control>
                <Accordion.Panel>
                  {responsible && (
                    <>
                      <span className={classes.accordionTitle}>
                        {responsible?.firstname} {responsible?.lastname}
                      </span>
                      <span className={classes.accordionSubTitle}>
                        {responsible?.email}
                        <br />
                        {responsible?.phonenumber?.[3]?.number}
                        <br />
                        {responsible?.address &&
                          `${responsible?.address?.street} ${responsible?.address?.streetNumber} ${responsible?.address?.zipCode} ${responsible?.address?.city}`}
                      </span>
                    </>
                  )}
                  <Responsible
                    authenticated={authenticated}
                    hasFee={hasFee}
                    newId={newId}
                    responsible={responsible}
                    selected={selected}
                    setSelected={setSelected}
                    ticketOwners={ticketOwners}
                    selectedDeliveryMethod={selectedDeliveryMethod}
                    providesResponsible={providesResponsible}
                    isGiftCertificate={paymentMethodId === GIFTCERTIFICATE}
                    submitNoToggleTerms={
                      context.state.giftCertificate?.coverTotalCost === false &&
                      submitNoToggleTerms
                    }
                  />
                </Accordion.Panel>
              </Accordion.Item>
            )}
          </Accordion>
        </div>
      )}
    </div>
  );
};

export default ChooseDelivery;
